import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../app-settings'

@Component({
  selector: 'app-delete-attendee-warning',
  templateUrl: './delete-attendee-warning.component.html',
  styleUrls: ['./delete-attendee-warning.component.css']
})
export class DeleteAttendeeWarningComponent implements OnInit {

  CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
  CONTACT_NAME = AppSettings.CONTACT_NAME

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/delete-attendee-warning/delete-attendee-warning.component.ts